import Vue from 'vue'
import "babel-polyfill"
import Vuex from 'vuex'
Vue.use(Vuex)
import state from './state'
import mutations from './mutations'
const store = new Vuex.Store({
    state,
    mutations
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js